import { render } from "./Sidebar.vue?vue&type=template&id=ba5ec2f4"
import script from "./Sidebar.vue?vue&type=script&lang=ts"
export * from "./Sidebar.vue?vue&type=script&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=ba5ec2f4&lang=scss"
script.render = render

export default script